import { ofType, combineEpics } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { NO_OP } from 'middleware/utils';
import {
  getNotificationListSuccess,
} from 'store/notification/actions';
import {
  GET_NOTIFICATION_LIST,
} from './actions';

const getNotificationListEpic = (action$, state$, { notificationRequest }) => action$.pipe(
  ofType(GET_NOTIFICATION_LIST),
  mergeMap((params) => {
    const { payload } = params;
    const { groupId, from, read } = payload;
    return notificationRequest.getNotificationList$(groupId, from, read).pipe(
      mergeMap((response) => {
        const { items } = response.data;
        return of(getNotificationListSuccess(items));
      }),
      catchError(() => of(NO_OP)),
    );
  }),
  catchError(() => of(NO_OP)),
);

export default combineEpics(
  getNotificationListEpic,
);
